import { useCallback, useEffect, useRef } from 'react';
export default function useSyncedHorizontalScroll() {
  const topScrollbarRef = useRef(null);
  const topScrollbarContentRef = useRef(null);
  const bottomScrollbarRef = useRef(null);
  const scrollContentRef = useRef(null);
  const scrollSourceRef = useRef(null);
  const updateTopScrollbarWidth = useCallback(() => {
    const bottomScrollbar = bottomScrollbarRef.current;
    const scrollContent = scrollContentRef.current || bottomScrollbar;
    const topScrollbar = topScrollbarRef.current;
    const topScrollbarContent = topScrollbarContentRef.current;
    if (!bottomScrollbar || !scrollContent || !topScrollbar || !topScrollbarContent) return;
    topScrollbarContent.style.width = "".concat(scrollContent.scrollWidth, "px");
    topScrollbar.scrollLeft = bottomScrollbar.scrollLeft;
  }, []);
  useEffect(() => {
    window.addEventListener('resize', updateTopScrollbarWidth);
    return () => {
      window.removeEventListener('resize', updateTopScrollbarWidth);
    };
  }, [updateTopScrollbarWidth]);
  const syncScrollbar = useCallback((sourceName, sourceRef, targetRef) => {
    const source = sourceRef.current;
    const target = targetRef.current;
    const targetName = sourceName === 'top' ? 'bottom' : 'top';
    if (!source || !target || scrollSourceRef.current === targetName) return;
    scrollSourceRef.current = sourceName;
    if (source.scrollLeft !== target.scrollLeft) {
      target.scrollLeft = source.scrollLeft;
    }
    requestAnimationFrame(() => {
      scrollSourceRef.current = null;
    });
  }, []);
  const onTopScrollbarScroll = useCallback(() => {
    syncScrollbar('top', topScrollbarRef, bottomScrollbarRef);
  }, [syncScrollbar]);
  const onBottomScrollbarScroll = useCallback(() => {
    syncScrollbar('bottom', bottomScrollbarRef, topScrollbarRef);
  }, [syncScrollbar]);
  return {
    bottomScrollbarRef,
    onBottomScrollbarScroll,
    onTopScrollbarScroll,
    scrollContentRef,
    topScrollbarContentRef,
    topScrollbarRef,
    updateTopScrollbarWidth
  };
}